import { registerVehicleExtensions } from '@core/models/entities/implementations/user-vehicle-v1';
import { GenericEntityRegistryService } from '@core/services/user-models-registry/generic-entity-registry.service';

import { registerDriverExtensions } from './user-driver-v1';
import { registerDriverWorkWindowExtensions } from './user-driver-work-window-v1';
import { registerGeoArcExtensions } from './user-geo-arc-v1';
import { registerGeographicAreaExtensions } from './user-geographic-area-v1';
import { registerJobTransportOrderExtensions } from './user-job-transport-order-v1';
import { registerJobVisitExtensions } from './user-job-visit-v1';
import { registerRouteActionExtensions } from './user-route-action-v1';
import { registerRouteExtensions } from './user-route-v1';
import { registerSiteScheduleExtensions } from './user-site-schedule-v1';
import { registerSiteExtensions } from './user-site-v1';
import { registerTrailerExtensions } from './user-trailer-v1';
import { registerWasteContainerJobExtensions } from './user-waste-container-job-v1';
import { registerWorkRegulationExtensions } from './user-work-regulation-v1';

export function registerAllEntityExtensions(registry: GenericEntityRegistryService): void {
  registerTrailerExtensions(registry);
  registerJobVisitExtensions(registry);
  registerDriverExtensions(registry);
  registerDriverWorkWindowExtensions(registry);
  registerRouteActionExtensions(registry);
  registerSiteExtensions(registry);
  registerSiteScheduleExtensions(registry);
  registerJobTransportOrderExtensions(registry);
  registerRouteExtensions(registry);
  registerWorkRegulationExtensions(registry);
  registerVehicleExtensions(registry);
  registerWasteContainerJobExtensions(registry);
  registerGeographicAreaExtensions(registry);
  registerGeoArcExtensions(registry);
}
